"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteTypes = void 0;
exports.SiteTypesFromJSON = SiteTypesFromJSON;
exports.SiteTypesFromJSONTyped = SiteTypesFromJSONTyped;
exports.SiteTypesToJSON = SiteTypesToJSON;
exports.SiteTypesToJSONTyped = SiteTypesToJSONTyped;
/**
 * Type of SiteTypes as types of site
 * @export
 * @enum {string}
 */
var SiteTypes;
(function (SiteTypes) {
    SiteTypes["Show"] = "show";
    SiteTypes["Channel"] = "channel";
})(SiteTypes || (exports.SiteTypes = SiteTypes = {}));
function SiteTypesFromJSON(json) {
    return SiteTypesFromJSONTyped(json, false);
}
function SiteTypesFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SiteTypesToJSON(value) {
    return SiteTypesToJSONTyped(value, false);
}
function SiteTypesToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
